var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"loading"},[_c('div',{staticClass:"loader"})]):_c('div',[_c('h1',{staticClass:"text-2xl"},[_vm._v("No "+_vm._s(_vm.type)+" found")])])
}
var staticRenderFns = []

export { render, staticRenderFns }